import { createFileRoute } from "@tanstack/react-router"
import { CommunicationTemplatesPage } from "@/pages"
import { AuthorizationGate } from "@/components"
import { Resource, Action } from "@mimber/schema"

export const Route = createFileRoute(
  "/_authenticated/_organization/communication/templates/"
)({
  component: () => (
    <AuthorizationGate
      resource={Resource.COMMUNICATION_TEMPLATES}
      action={Action.READ}
    >
      <CommunicationTemplatesPage />
    </AuthorizationGate>
  ),
})
